module.exports = {"conf":{"pattern":{"size":80,"rows":3,"strokeWidth":2},"grid":{"borderWidth":"1px","cellWidth":"186px"}}}